module.exports = __webpack_public_path__ + "static/case_04-d43f53b2119f1ab4d0749776cc99bf91.jpg";